/**
 * How long the client's complexity claim may be.
 *
 * Shared rather than declared twice because the two ends enforce it for
 * different reasons and a drift between them is silent in the worst
 * direction: the form stops the text being typed, the router rejects it if it
 * arrives anyway. A client-side cap looser than the server's would make every
 * subsequent autosave of that whole post-mortem fail zod — and the autosave
 * has nowhere to report that, so the answers and rating typed afterwards would
 * be dropped with the UI still looking normal.
 *
 * No runtime dependencies on purpose: the browser bundle imports this, so it
 * must not drag in drizzle, the db, or the router.
 */

/** A big-O expression: `O(n log n)`, `O(n² + m)`. Short by nature. */
export const COMPLEXITY_MAX_LENGTH = 100

/** The sentence defining its variables. Longer, still one line. */
export const COMPLEXITY_EXPLANATION_MAX_LENGTH = 500
